import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  createTemplate,
  fetchTemplate,
  deleteTemplate,
  updateTemplate,
  duplicateTemplate,
  createTestEmail
} from "../actions/index";
import { Link } from "react-router-dom";
import TemplatesForm from "./TemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import { Modal } from "react-bootstrap";
import * as Constants from '../constants';

class TemplatesEdit extends Component {
  static propTypes = {
    createTemplate: PropTypes.func.isRequired,
    fetchTemplate: PropTypes.func.isRequired,
    duplicateTemplate: PropTypes.func.isRequired,
    deleteTemplate: PropTypes.func.isRequired,
    updateTemplate: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    template: PropTypes.object,
    createTestEmail: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      showModal: false,
      duplicateName: ""
    };
  }

  componentDidMount() {
    this.props.fetchTemplate(
      this.props.match.params.id
    );
  }

  onDeleteClickConfirmation() {
    const msg =
      "Are you sure you want to delete this template? You cannot undo deletion.";
    const toastrConfirmOptions = {
      onOk: () => this.onDeleteClick()
    };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  onDeleteClick() {
    this.props
      .deleteTemplate(this.props.match.params.id)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Email Template deleted!");
          this.props.history.push(`/templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  onDuplicateClick() {
    this.props
      .duplicateTemplate(
        this.props.match.params.id,
        this.props
      )
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Email Template duplicated!");
          this.props.history.push(`/templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  onUpdateEverywhereConfirmation(state) {
    this.setState({
      formData: {
        body: state.body,
        email_template_category_id: state.email_template_category_id,
        name: state.name,
        subject: state.subject
      }
    });
    const msg =
      "Warning: This email template is used in more than one place. Would you like to change it everywhere or just here?";
    const toastrConfirmOptions = {
      okText: "Update Everywhere",
      cancelText: "Update Current",
      onOk: () => this.updateTemplate(state),
      onCancel: () => this.copyTemplate(state)
    };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  onSubmit(state) {
    if (this.props.template.data.campaigns_using.length > 1) {
      this.onUpdateEverywhereConfirmation(state);
    } else {
      this.updateTemplate(state);
    }
  }

  copyTemplate(state) {
    this.openModal();
  }

  handleChangeDuplicateName(e) {
    const name = e.target.value;
    this.setState({ duplicateName: name });
  }

  onSubmitCopy(state) {
    let data = Object.assign(this.state.formData, {
      name: this.state.duplicateName
    });
    this.props
      .createTemplate(data)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Email Template created!");
          this.props.history.push(`/templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  updateTemplate(state) {
    this.props
      .updateTemplate(
        this.props.match.params.id,
        state
      )
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Email Template saved!");
          this.props
            .fetchTemplate(
              this.props.match.params.id
            )
            .then(() => {
              this.props.history.push(`/templates?${Constants.DEFAULT_PAGINATION}`);
            });
        }
      });
  }

  sendTestEmail(state) {
    this.props
      .createTestEmail(state)
      .then(response => {
        if (response.payload.status == 200) {
          toastr.success("Test Email Sent!");
        }
      });
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  campaignsUsing() {
    if (this.props.template.data.campaigns_using.length == 0) {
      return <div />;
    }
    let campaigns_using = this.props.template.data.campaigns_using.map((
      campaign, index) => {
        return (
          <tr key={index}>
            <td>
              <Link
                to={`/campaigns/${ campaign.id }`}
              >
                {campaign.name}
              </Link>
            </td>
            <td className="text-right">
              <Link
                to={`/campaigns/${ campaign.id }`}
                className="btn btn-sm btn-primary template_edit"
              >
                Edit
              </Link>
            </td>
          </tr>
        );
      }
    );
    return (
      <div className="m-t-20 clearfix">
        <h4>Workflows using this template</h4>
        <table className="table table-striped">
          <tbody>{campaigns_using}</tbody>
        </table>
      </div>
    );
  }

  render() {
    const { template } = this.props;
    if (!template) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }

    return (
      <div>
        <h1>Edit Template</h1>
        <TemplatesForm
          key={template.data.id}
          handleSubmit={this.onSubmit.bind(this)}
          handleSendTestEmail={this.sendTestEmail.bind(this)}
          mode="edit"
          match={this.props.match}
          name={template.data.name}
          categories={template.data.categories}
          videoTemplates={template.data.video_templates}
          email_template_category_id={template.data.email_template_category_id}
          subject={template.data.subject}
          body={template.data.body}
        />
        <Link
          to={`/templates?${Constants.DEFAULT_PAGINATION}`}
          className="btn btn-default pull-left m-r-10"
        >
          Back
        </Link>
        <button
          className="btn btn-primary pull-left m-r-10 duplicate_template_btn"
          onClick={this.onDuplicateClick.bind(this)}
        >
          Duplicate Template
        </button>
        <button
          className="btn btn-danger pull-left delete_template_btn"
          onClick={this.onDeleteClickConfirmation.bind(this)}
        >
          Delete Template
        </button>
        {this.campaignsUsing()}

        <Modal
          show={this.state.showModal}
          onHide={this.closeModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              New Email Template
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className={`form-group ${
                name.touched && name.invalid ? "has-error" : ""
              }`}
            >
              <label>Name</label>
              <input
                type="text"
                className="form-control name_field"
                onChange={this.handleChangeDuplicateName.bind(this)}
                value={this.state.duplicateName}
              />
              <div className="help-block">{name.touched ? name.error : ""}</div>
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.onSubmitCopy.bind(this)}
            >
              Save
            </button>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { template: state.templates.template };
}

export default connect(
  mapStateToProps,
  {
    createTemplate,
    fetchTemplate,
    updateTemplate,
    deleteTemplate,
    duplicateTemplate,
    createTestEmail
  }
)(TemplatesEdit);
